import { render, staticRenderFns } from "./LikeTeacher.vue?vue&type=template&id=59c1ea5e&"
import script from "./LikeTeacher.vue?vue&type=script&lang=js&"
export * from "./LikeTeacher.vue?vue&type=script&lang=js&"
import style0 from "./LikeTeacher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LikeTeacher.vue"
export default component.exports